import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const ThemeCtx = createContext(null);
export const useTheme = () => useContext(ThemeCtx);

const STORAGE_KEY = "mlima_theme";

export function ThemeProvider({ children }) {
    const [theme, setTheme] = useState(() => {
        if (typeof window === "undefined") return "light";
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved) return saved;
        return window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    });

    useEffect(() => {
        const root = document.documentElement;
        root.classList.toggle("dark", theme === "dark");
        localStorage.setItem(STORAGE_KEY, theme);
        // Update meta theme-color for PWA browser chrome
        const meta = document.querySelector('meta[name="theme-color"]');
        if (meta) meta.setAttribute("content", theme === "dark" ? "#0A0A0A" : "#922529");
    }, [theme]);

    const toggle = useCallback(() => setTheme((t) => (t === "dark" ? "light" : "dark")), []);

    // Stable value reference — avoids forcing every context consumer to
    // re-render on unrelated parent re-renders.
    const value = useMemo(() => ({ theme, setTheme, toggle }), [theme, toggle]);

    return (
        <ThemeCtx.Provider value={value}>{children}</ThemeCtx.Provider>
    );
}
